import styled from '@emotion/styled';
import { useGlobal } from '../../hooks';
import { HeaderLogo } from './HeaderLogo';
import { ReactNode } from 'react';
import { mqDown } from 'rwl-ui';
import { ReviewTotals } from '../ReviewTotals';
import { Else, If, Then } from 'react-if';

const HeaderContainer = styled.header(
    ({ breakpoint }: { breakpoint?: any }) => `
    height: var(--rwl-header-height);
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    border-bottom: 1px solid var(--rwl-color-neutral-border);
    container-type: inline-size;
    container-name: header;
    position: relative;

    ${breakpoint && mqDown(breakpoint)} {
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: var(--rwl-xs-header-height);
    }
`
);

const LogoAndReviewsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    width: 100%;

    ${mqDown('sm')} {
        align-items: center;
        justify-content: space-around;
    }
`;

interface HeaderProps {
    breakpoint?: string;
    hideAggregates?: boolean;
    children?: ReactNode;
}

export const Header = ({
    breakpoint,
    hideAggregates,
    children,
}: HeaderProps) => {
    const { config } = useGlobal();
    if (!config || !config.extraData) {
        return <HeaderContainer />;
    }
    return (
        <HeaderContainer className="headerContainer" breakpoint={breakpoint}>
            <If condition={hideAggregates}>
                <Then>
                    <HeaderLogo
                        url={config.extraData.logo}
                        name={config.account.name}
                    />
                </Then>
                <Else>
                    <LogoAndReviewsWrapper>
                        <HeaderLogo
                            url={config.extraData.logo}
                            name={config.account.name}
                        />

                        <ReviewTotals />
                    </LogoAndReviewsWrapper>
                </Else>
            </If>
            {children}
        </HeaderContainer>
    );
};
